import { render } from "./DocumentTypeGrid.vue?vue&type=template&id=3a97e182&scoped=true"
import script from "./DocumentTypeGrid.vue?vue&type=script&lang=js"
export * from "./DocumentTypeGrid.vue?vue&type=script&lang=js"

import "./DocumentTypeGrid.vue?vue&type=style&index=0&id=3a97e182&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a97e182"]])

export default __exports__